export default "/images/framework/Discord.bfb970d2.svg?bfb970d2";